import "./config";
import React from "react";
import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { LottoContextProvider } from "./context/lottoContext";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "src/assets/scss/style.scss";
import "src/components/WageringStatus.css";
import setupLocatorUI from "@locator/runtime";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LottoContextProvider>
    <App />
  </LottoContextProvider>
);

serviceWorkerRegistration.unregister();

reportWebVitals();
